export const TOGGLE_FOLDED_NAVBAR = 'TOGGLE_FOLDED_NAVBAR';
export const navbarToggleFolded = () => ({
	type: TOGGLE_FOLDED_NAVBAR
});

export const OPEN_FOLDED_NAVBAR = 'OPEN_FOLDED_NAVBAR';
export const navbarOpenFolded = () => ({
	type: OPEN_FOLDED_NAVBAR
});

export const CLOSE_FOLDED_NAVBAR = 'CLOSE_FOLDED_NAVBAR';
export const navbarCloseFolded = () => ({
	type: CLOSE_FOLDED_NAVBAR
});

export const TOGGLE_MOBILE_NAVBAR = 'TOGGLE_MOBILE_NAVBAR';
export const navbarToggleMobile = () => ({
	type: TOGGLE_MOBILE_NAVBAR
});

export const OPEN_MOBILE_NAVBAR = 'OPEN_MOBILE_NAVBAR';
export const navbarOpenMobile = () => ({
	type: OPEN_MOBILE_NAVBAR
});

export const CLOSE_MOBILE_NAVBAR = 'CLOSE_MOBILE_NAVBAR';
export const navbarCloseMobile = () => ({
	type: CLOSE_MOBILE_NAVBAR
});
